
export default class PublishOrPreviewCheck {

    get( vm )
    {
        let api_url = '/wp-json/wp/v2/' + vm.api_post_type + '?slug=' + vm.$route.params.pageSlug;
        if( vm.$route.params.hasOwnProperty('postSlug'))
        {
            api_url = '/wp-json/wp/v2/' + vm.api_post_type + '?slug=' + vm.$route.params.postSlug;
        }
        if (vm.$route.query.preview !== undefined && vm.$route.query.preview == 'true') {

            let id_to_use = (vm.$route.query.hasOwnProperty('preview_id')) ? vm.$route.query.preview_id : (vm.$route.query.hasOwnProperty('page_id') ? vm.$route.query.page_id: vm.$route.query.p );
            let previews_url = '/wp-json/wp/v2/' + vm.api_post_type + '/' + id_to_use + '/revisions/?_wpnonce=' + window.grpl_nonce;

            axios.get(previews_url).then((response) => {
                api_url = '/wp-json/wp/v2/' + vm.api_post_type + '/' + id_to_use + '/revisions/' + response.data[0].id + '?_wpnonce=' + window.grpl_nonce;
                axios.get(api_url)
                    .then(response => {
                        if (response.hasOwnProperty('data')) {
                            vm.page = response.data;
                            if (vm.api_post_type  == 'posts' ){
                                vm.getRelatedArticles();
                            }
                            vm.$store.dispatch('updatePage', vm.page);
                        } else {
                            return vm.$router.replace('/404');
                        }
                    })
                    .catch(error => {
                        return vm.$router.replace('/404');
                    });
            });

        } else {

            axios.get(api_url)
                .then(response => {
                    if (response.data.length > 0) {
                        vm.page = response.data[0];
                        if (vm.api_post_type == 'posts') {
                            vm.getRelatedArticles();
                        }
                        vm.$store.dispatch('updatePage', vm.page);
                    } else {
                        return vm.$router.replace('/404');
                    }
                })
                .catch(error => {
                    return vm.$router.replace('/404');
                });
        }
    }

}